import { MORTALITY_RESIDUES } from '../../utils/residuosObservacionesAuto';

/**
 * Construye el bloque de glosas para el DscItem de cada ítem de residuo.
 * Incluye: ORIGEN/DESTINO, tipo de traslado, y NO APTO PARA CONSUMO HUMANO (si aplica).
 */
export const buildGlosasBlockForDscItem = (values, residueId) => {
	const origen = values.center_origin || 'ORIGEN NO ESPECIFICADO';

	const destinyType = values.destiny_type_id;
	let destino = 'DESTINO NO ESPECIFICADO';
	if (destinyType === '1') {
		const receptorName = values.receptor_name || '';
		const parts = receptorName.split(' - ');
		destino =
			parts.length > 1
				? parts[1].trim()
				: receptorName || 'BODEGA NO ESPECIFICADA';
	} else if (destinyType === '2') {
		destino = values.receptor_name || 'DESTINO FINAL NO ESPECIFICADO';
	}

	const transportIndex = values.transport_index;
	const isConstituyeVenta = transportIndex === 1 || transportIndex === '1';
	const trasladoText = isConstituyeVenta
		? 'EL TRASLADO CONSTITUYE VENTA'
		: 'EL TRASLADO NO CONSTITUYE VENTA';

	const isMortalidad = MORTALITY_RESIDUES.includes(residueId);

	let glosas = `ORIGEN/DESTINO\n${origen}/${destino}\n\n${trasladoText}`;

	if (isMortalidad) {
		glosas += '\n\nNO APTO PARA CONSUMO HUMANO';
	}

	return glosas;
};
